import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('tgg_user');
    const token = localStorage.getItem('tgg_token');
    if (savedUser && token) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const response = await authAPI.login(username, password);
      if (response.data.success) {
        localStorage.setItem('tgg_token', response.data.token);
        localStorage.setItem('tgg_user', JSON.stringify(response.data.user));
        setUser(response.data.user);
        return true;
      }
      return false;
    } catch (err) {
      if (err.response?.status === 401) {
        return false;
      }
      throw err;
    }
  };

  const logout = () => {
    localStorage.removeItem('tgg_token');
    localStorage.removeItem('tgg_user');
    setUser(null);
  };

  const updateProfile = async (data) => {
    const response = await authAPI.updateProfile(data);
    if (response.data.success) {
      const updatedUser = { ...user, ...data };
      localStorage.setItem('tgg_user', JSON.stringify(updatedUser));
      setUser(updatedUser);
      return true;
    }
    return false;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateProfile, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
